import React, { FC, ReactNode } from 'react';

import { Typography, styled, Theme } from '@material-ui/core';

import { Card, CardContent, CardHeader } from '../../shared/components';

const DashboardCardHeader = styled(CardHeader)<Theme>(({ theme }) => ({
  padding: theme.spacing(4, 3),
}));

const DashboardCardContent = styled(CardContent)<Theme>(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(2),
}));

type DashboardItemWrapperProps = {
  title: string;
  header?: ReactNode;
  id?: string;
  children?: ReactNode;
};

const DashboardItem: FC<DashboardItemWrapperProps> = ({
  title,
  children,
  header,
  id,
}: DashboardItemWrapperProps) => (
  <Card id={id} className="rounded" elevation={0}>
    <DashboardCardHeader>
      <Typography variant="h2">{title}</Typography>
      {header}
    </DashboardCardHeader>
    <DashboardCardContent>{children}</DashboardCardContent>
  </Card>
);

export default DashboardItem;
